import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { ButtonGroup } from "@vds/buttons";
import { Input } from "@vds/inputs";
import { DropdownSelect } from "@vds/selects";
import { useEffect, useState } from "react";
import { Form, Link, useNavigate } from "react-router-dom";

import { createCVApplicationEndPoint } from "../../../configuration";
// import { createappCVApplicationEndPoint } from "../../../configuration";
import { useSelector } from "react-redux";
import axiosInstance from "../../../global/axiosInterceptor";
import { CVAPPS_TEST_IDS } from "../cvAppsConstants";


const CreateCVApps = (props) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  let navigate = useNavigate();
  let nameSelected = "";
  let valueSelected = "";

  let editRule = false;

  const [deviceList, setDeviceList] = useState([]);
  useEffect(() => {
    const deviceList = [...JSON.parse(sessionStorage.getItem("deviceList"))];
    setDeviceList([...deviceList]);
  }, []);

  const [createCVApps, setCreateCVApps] = useState(false);

  const [formData, setFormData] = useState({
    nameSelected: "",
    valueSelected: "",
  });

  const [name, setName] = useState();
  const [type, setType] = useState();
  const [image, setImage] = useState();
  const [version, setVersion] = useState();
  const [cpu, setCpu] = useState();
  const [memory, setMemory] = useState();

  const createCV = async () => {
    try {
      const cvAppResp = await axiosInstance.post(
        createCVApplicationEndPoint(),
        {
          // accountname: sessionStorage.getItem("accountId"),
          // type: "docker image",
          // image:image,
          // version:version,
          // cpu:cpu,
          // memory:memory,

          accountname: activeSession.accountId,
          cvapp: {
            image: image,
            name: name,
            resources: {
              cpu: cpu,
              memory: memory,
            },
            status: "active",
            type: "docker image",
            version: version,
          },
        }
      );

      const res = cvAppResp.data;
      setCreateCVApps(res);

      const status = cvAppResp.status;
      console.log(res);
      navigate(-1);

      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } catch (e) {
      console.log(e);
    }
  };
  const cancelButton = () => {
    navigate(-1);
  };

  const handleButton = () => {
    createCV();
    // navigate(-1);
  };
  return (
    <>
      <div style={{ marginBottom: "30px" }}>
        <Breadcrumbs surface="light">
          <BreadcrumbItem>Dashboard</BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              data-testid="createCvApps_cvAppsLink"
              to="/cvApps"
              className="breadcrums-item_link"
            >
              CVApps
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>Create CVApps </BreadcrumbItem>
        </Breadcrumbs>
        <h2 className={"font-face-vzb"}>
          {editRule ? "Edit rule" : "Create CVApps"}
        </h2>
      </div>
      {deviceList && deviceList.length > 0 && (
        <Form>
          <Input
            type="text"
            label="Name"
            width="30%"
            readOnly={false}
            disabled={false}
            error={false}
            defaultValue={nameSelected}
            className="sasp_create-edit-rule-dropdown"
            errorText="Rule name cannot be empty!!"
            value={name}
            data-testid={CVAPPS_TEST_IDS.CVAPPS_NAME_INPUT}
            onChange={(e) => setName(e.target.value)}
            // tooltipTitle="Name"
          />
          <DropdownSelect
            label="Type "
            errorText="At least one type should be selected"
            error={false}
            disabled={editRule}
            readOnly={false}
            inlineLabel={false}
            className="sasp_create-edit-rule-dropdown"
            style={{ paddingTop: "2rem" }}
            width="30%"
            value={"docker image"}
            onChange={(e) => setType(e.target.value)}
            data-testid={CVAPPS_TEST_IDS.CVAPPS_TYPE_DROPDOWN}
            // tooltipTitle="Select a type"
          >
            <option value="docker image">docker image</option>
            {/* <option key="sensor_0">docker image2</option> */}
          </DropdownSelect>
          <Input
            type="text"
            label="Image"
            width="30%"
            readOnly={false}
            disabled={false}
            error={false}
            defaultValue={nameSelected}
            className="sasp_create-edit-rule-dropdown"
            // onChange={(e) => handleDropdownChange(e.target.value, setRuleName)}
            errorText="Rule name cannot be empty!!"
            value={image}
            onChange={(e) => setImage(e.target.value)}
            data-testid={CVAPPS_TEST_IDS.CVAPPS_IMAGE_INPUT}
            // tooltipTitle="Name your Rule"
          />
          <Input
            type="text"
            label="Version"
            width="30%"
            readOnly={false}
            disabled={false}
            error={false}
            defaultValue={nameSelected}
            className="sasp_create-edit-rule-dropdown"
            // onChange={(e) => handleDropdownChange(e.target.value, setRuleName)}
            errorText="Rule name cannot be empty!!"
            // tooltipTitle="Name your Rule"
            value={version}
            onChange={(e) => setVersion(e.target.value)}
            data-testid={CVAPPS_TEST_IDS.CVAPPS_VERSION_INPUT}
          />
          <h5>Resources: </h5>
          <Input
            type="text"
            label="CPU"
            width="30%"
            //tooltipTitle="Enter a value"
            className="sasp_create-edit-rule-dropdown"
            readOnly={false}
            disabled={false}
            error={false}
            defaultValue={valueSelected}
            errorText="Enter a value."
            value={cpu}
            onChange={(e) => setCpu(e.target.value)}
            data-testid={CVAPPS_TEST_IDS.CVAPPS_CPU_INPUT}
          />
          <Input
            type="text"
            label="Memory"
            width="30%"
            //tooltipTitle="Enter a value"
            className="sasp_create-edit-rule-dropdown"
            readOnly={false}
            required={true}
            disabled={false}
            error={false}
            defaultValue={valueSelected}
            errorText="Enter a value."
            value={memory}
            onChange={(e) => setMemory(e.target.value)}
            data-testid={CVAPPS_TEST_IDS.CVAPPS_MEMORY_INPUT}
          />
          <ButtonGroup
            childWidth={"100%"}
            viewport={"desktop"}
            rowQuantity={{ desktop: 2 }}
            data={[
              {
                children: "Back",
                size: "large",
                use: "secondary",
                width: "125px",
                onClick: cancelButton,
                "data-testid": CVAPPS_TEST_IDS.CVAPPS_CANCEL_BUTTON,
              },
              {
                children: "Submit",
                size: "large",
                use: "primary",
                width: "125px",
                onClick: handleButton,
                "data-testid": CVAPPS_TEST_IDS.CVAPPS_SUBMIT_BUTTON,
                disabled: !(name && image && version && cpu && memory),
              },
            ]}
            alignment={"left"}
          />
        </Form>
      )}
    </>
  );
};
export default CreateCVApps;
